import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorBurnoutEfficacy = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Eficacia Alto"
        return "green";
      case 1:
        textRisk = "Eficacia Medio"
        return "yellow";
      case 2:
        textRisk = "Eficacia Bajo"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">{category}</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorBurnoutEfficacy;
